export default {
    "title": "Panel de Administración / Clientes",
    "description": "Listado de clientes actualmente dados de alta",
    "clientsTableHeader": "Total: <0>{{count}}</0> | Activos: <0>{{countActive}}</0> | Inactivos: <0>{{countInactive}}</0>",
    "clientName": "Nombre cliente",
    "clientsTableColumns": {
        "client_name": "Nombre cliente",
        "client_id": "Identificador SAP",
        "cif": "CIF",
        "date": "Fecha de alta",
        "users_count": "Número de usuarios",
        "state": "Estado"
    },
    "popover": {
        "edit": "Editar",
        "activate": "Activar",
        "deactivate": "Desactivar",
        "documentation": "Documentación",
        "delete": "Eliminar"
    },
    "newClientDialog": {
        "title": "Crear cliente",
        "input": {
            "name": "Nombre *",
            "placeholder_name": "Nombre nuevo cliente",
            "sap": "Identificador SAP *",
            "placeholder_sap": "Identificador SAP nuevo cliente",
            "nif": "NIF *",
            "placeholder_nif": "NIF nuevo cliente",
            "cancel": "Cancelar"
        }
    },
    "servicesSection": {
        "title": "Servicios"
    },
    "editClientDialog": {
        "title": "Editar cliente",
        "input": {
            "name": "Nombre *",
            "placeholder_name": "Editar nombre cliente",
            "sap": "Identificador SAP *",
            "placeholder_sap": "Editar identificador SAP cliente",
            "nif": "NIF *",
            "placeholder_nif": "Editar NIF cliente",
            "cancel": "Cancelar",
            "save": "Guardar"
        }
    },
    "deactivateClientDialog": {
        "title": "Desactivar cliente",
        "sap": "Identificador SAP:",
        "nif": "NIF:",
        "text1": "Se va a desactivar el cliente, ¿estás seguro?",
        "text2": "Automáticamente se desactivarán todos los usuarios asociados al cliente, por lo que no se podrán conectar",
        "deactivate": "Desactivar cliente"
    },
    "activateClientDialog": {
        "title": "Activar cliente",
        "sap": "Identificador SAP:",
        "nif": "NIF:",
        "text1": "Se va a activar el cliente, ¿estás seguro?",
        "text2": "Se deben activar manualmente los usuarios asociados al cliente para que puedan acceder.",
        "activate": "Activar cliente"
    },
    "documentationClientDialog": {
        "title": "Documentación del cliente",
        "sap": "Identificador SAP: ",
        "nif": "NIF: ",
        "availableDocumentation": "Documentos disponibles",
        "table": {
            "documentName": "Nombre documento",
            "type": "Tipo",
            "size": "Tamaño"
        },
        "input":{
            "label": {
                "fileName": "Nombre ",
                "startDate": "Fecha de inicio",
                "endDate": "Fecha de caducidad",
                "description": "Descripción",
                "uploadFile": "Seleccionar fichero"
            },
            "addDocument": "Añadir documento",
            "editDocument": "Editar documento",
            "add": "Añadir",
            "save": "Guardar documento",
            "cancel": "Cancelar",
            "close": "Cerrar",
            "upload": "Añadir documento",
            "delete": "Eliminar documento",
            "deleteText": "Se va a eliminar el siguiente documento, ¿Estás seguro?"
        }
    },
    "deleteClientDialog": {
        "title": "Eliminar cliente",
        "sap": "Identificador SAP:",
        "nif": "NIF:",
        "text1": "Se va a eliminar el cliente, ¿estás seguro?",
        "text2": "Automáticamente se eliminarán todos los usuarios asociados al cliente, por lo que no se podrán conectar.",
        "delete": "Eliminar cliente"
    },
    "stateTag": {
        "active": "Activo",
        "inactive": "Inactivo"
    },
    "toaster": {
        "success": {
            "createClient": "Cliente creado correctamente",
            "updateClient": "Cliente modificado correctamente",
            "createDocument": "Documento creado correctamente",
            "updateDocument": "Documento modificado correctamente",
            "deleteDocument": "Documento eliminado correctamente"
        },
        "error": {
            "createDocument": "Error al crear documento",
            "updateDocument": "Error al editar documento",
            "deleteDocument": "Error al eliminar documento"

        }
    }
};